var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#111111",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z",
    stroke: "#111111",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 14C25.5 14.4442 25.3069 14.8434 25 15.1181V17H30C31.6569 17 33 18.3432 33 20V30C33 31.6569 31.6569 33 30 33H18C16.3432 33 15 31.6569 15 30V20C15 18.3432 16.3432 17 18 17H23V15.1181C22.6931 14.8434 22.5 14.4442 22.5 14C22.5 13.1716 23.1716 12.5 24 12.5C24.8284 12.5 25.5 13.1716 25.5 14ZM12 22H14V28H12V22ZM36 22H34V28H36V22ZM21 26.5C21.8284 26.5 22.5 25.8284 22.5 25C22.5 24.1716 21.8284 23.5 21 23.5C20.1716 23.5 19.5 24.1716 19.5 25C19.5 25.8284 20.1716 26.5 21 26.5ZM28.5 25C28.5 24.1716 27.8284 23.5 27 23.5C26.1716 23.5 25.5 24.1716 25.5 25C25.5 25.8284 26.1716 26.5 27 26.5C27.8284 26.5 28.5 25.8284 28.5 25Z",
    fill: "#111111",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/1_8.d60a16382a259f51558b0f18381e5a95.svg";
export { ForwardRef as ReactComponent };